import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { globalStatistic } from '../redux/actions/otherActions';
import PageHelmet from '../components/helmet/PageHelmet';
import PageBanner from '../components/banner/PageBanner';
import { getPageSeo } from "../redux/actions/pageActions";
import { useTranslation } from "react-i18next";

const EweKyoceraPartnership = () => {
    const dispatch = useDispatch();
    const [pageSeoData, setPageSeoData] = useState({});
    const { t } = useTranslation('eweKyoceraPartnershipPage');

    useEffect(() => {
        dispatch(getPageSeo(1258)).then((res) => {
            if (res) {
                setPageSeoData(res);
            }
        });
        dispatch(globalStatistic(1258, "PAGE"));
    }, [dispatch]);

    return (
        <>
            {Object.keys(pageSeoData).length !== 0 && (
                <PageHelmet
                    title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
                    description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
                    ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
                    ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
                    ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
                    twitterDescription={
                        pageSeoData ? `${pageSeoData.acSeoDescription}` : ""
                    }
                />
            )}
            <div className="container-content container-main-content newsletter-content top-margin-navbar-escape">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="banner-image-on-top-page">
                                <PageBanner categoryType="" categoryId="" pageId="1258" />
                            </div>
                            <div className="stats-order-content-holder">
                                <h1>{pageSeoData.acSeoHeader ? pageSeoData.acSeoHeader : t('glavniNaslov')}</h1>
                            </div>
                            <div className="contact-desc" style={{ marginBottom: "20px" }}>
                                {t('partnerstvoOpis')}
                            </div>
                            <div style={{ marginBottom: "30px" }}>
                                <a
                                    href="https://resource.ewe.rs/media/Uputstvo - Utvrđivanje statusa partnerstva za portfolio Kyocera.pdf"
                                    className="btn btn-info"

                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('usloviPartnerstva')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EweKyoceraPartnership;
